import React from 'react'
import AddGAAlbumContainer from '../../modules/GAAlbums/containers/AddGAAlbumContainer/AddGAAlbumContainer'

const AddGAAlbum = () => {
  return (
    <AddGAAlbumContainer />
  )
}

export default AddGAAlbum